import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "../../Styles/auth/auth.scss";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { useNavigate } from "react-router-dom";
import isoEventLogo from "./../../assets/images/Logo/Logo-Pazirex-Blue.svg";
import LoginStep from "../../utilities/functions/loginProcessStep";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";
import { maskedPhoneNumber, formattedTimer } from '../../utilities/functions/utils'
import AuthFooter from "../../components/AuthFooter";
import useCenteredPage from "../../Hooks/useCenteredPage";

const TwoFA = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { token, roles } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(60); // Initial timer value in seconds
  const [loginCode, setLoginCode] = useState([])
  const [activeOtpField, setActiveOtpField] = useState(0)
  const twofaWrapperRef = useRef()

  const mobile = localStorage.getItem("mobile");
  const headers = { Authorization: "Bearer " + localStorage.getItem("tokenfa") };

  useCenteredPage(twofaWrapperRef)

  const twoFAcode = useMemo(() => {
    return loginCode.filter(code => !!String(code).trim().length)?.join('')
  }, [loginCode])

  const updateInputFiled = (index, value) => {

    value = String(value)?.at(-1);
    const nextInputFiledDirection = value === undefined ? -1 : 1;

    setActiveOtpField(index + nextInputFiledDirection);

    (
      () => {

        if (!loginCode.length || loginCode.length <= index) {
          setLoginCode(prev => [...prev, value])
          return
        }

        if (!value) return setLoginCode(prev => prev.filter((_, valIndex) => valIndex !== index))

        setLoginCode(prev => prev.map((loginValue, loginIndex) => {
          if (loginIndex == index) loginValue = value
          return loginValue;
        }))

      }
    )()

    document.querySelector(`#otp-code-${index + nextInputFiledDirection}`)?.focus();
    document.querySelector(`#otp-code-${index}`).value = value

  }

  const resetInputFields = () => {
    [0, 1, 2, 3].forEach(index => {
      const inputTarget = document.querySelector(`#otp-code-${index}`)
      if (inputTarget) {
        inputTarget.value = ''
        index === 0 && inputTarget.focus()
      }
    })
    setLoginCode([])
  }

  const twofaAPI = (e) => {

    e?.preventDefault(); // Prevent form submission

    if (twoFAcode?.length !== 4) return toast.error('کد تایید را بصورت کامل وارد کنید.')

    const registerRequestParams = { verification_code: twoFAcode }

    setLoading(true);

    axios
      .post(serverConfig.server.url + apiConfig.api.authControllers.twofa, registerRequestParams, { headers })
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          localStorage.setItem('res', JSON.stringify(registerRequestParams))
          if (response.data.data.registered) {
            localStorage.removeItem("tokenfa");
            localStorage.setItem("token", response.data.data.token);
            dispatch(
              setUser({
                first_name: response.data.data.first_name,
                last_name: response.data.data.last_name,
                token: response.data.data.token,
                roles: response.data.data.user_roles,
              })
            );

            const turnIdCallback = sessionStorage.getItem('redirect-after-login')
            if (turnIdCallback) return navigate(`/turn?id=${turnIdCallback}`);

            (
              localStorage.getItem("callBackURL")
              &&
              (localStorage.getItem("callBackURL") != "/login" || localStorage.getItem("callBackURL") != "/twofa" || localStorage.getItem("callBackURL") != "/register")
            )
              ?
              window.location.replace(localStorage.getItem("callBackURL"))
              :
              window.location.replace("/");

          } else {
            localStorage.removeItem("tokenfa");
            localStorage.setItem("tokenreg", response.data.data.token);
            navigate("/register");
          }
        } else if (response.data.code === 401) {
          toast.error("کد تایید منقضی شده است");
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  const backToLogin = () => {
    resetInputFields()
    localStorage.removeItem("tokenfa");
    localStorage.removeItem("mobile");
    localStorage.setItem(
      "callBackURL",
      window.location.pathname + window.location.search
    );
    navigate("/login");
  };

  const loginAPI = () => {

    const apiParams = {
      mobile
    }

    const referrer_id = localStorage.getItem('referrer_id')

    if (referrer_id) {
      apiParams.referrer_id = referrer_id
    }

    resetInputFields()

    setLoading(true);
    axios
      .post(serverConfig.server.url + apiConfig.api.authControllers.login, apiParams)
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          localStorage.setItem("tokenfa", response.data.data.token);
          localStorage.setItem("mobile", mobile);
          response.data.data.verification_code &&
            toast.success(response.data.data.verification_code);
          // Reset the timer when resend is clicked
          setResendTimer(60);
        } else {
          if (typeof response.data.errors === 'string') {

            // remove the invalid referre_id and re-call the login route again
            if (response?.data?.errors === 'چنین سایتی وجود ندارد!') {
              localStorage.removeItem('referrer_id')
              loginAPI()
              return
            }

            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };

  useEffect(() => { loginCode?.length === 4 && twofaAPI() }, [loginCode]) // auto submit on filled otp options

  useEffect(() => {
    const timer = setInterval(() => {
      setResendTimer((prevTimer) => prevTimer - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    let step = LoginStep();
    if (step !== "OK" && step) navigate(step);
  }, []);

  return (
    <section ref={twofaWrapperRef} className="tw-flex tw-items-center tw-justify-center tw-h-screen tw-max-w-full md:tw-max-w-[500px] tw-m-auto">
      <div className="card-body border-gray-400 tw-rounded-2xl tw-border-0 md:tw-border tw-p-5 md:tw-p-8">
        <img
          src={isoEventLogo}
          className="logo-img d-flex mx-auto tw-w-[55%] tw-h-auto tw-mb-12"
          alt="..."
        />
        <div className="card-body">
          <h5 className="tw-text-[20px] tw-font-medium">کد تایید را وارد کنید</h5>
          <p className="tw-text-sm tw-font-normal tw-text-[#495057]">کد ۵ رقمی به شماره {maskedPhoneNumber(mobile)} ارسال شد. کد را در کادر زیر وارد کنید.</p>
          <form onSubmit={twofaAPI} className="d-flex flex-column tw-hidden">

            <div className="tw-flex tw-flex-col tw-gap-3 text-start">

              <div
                className="tw-flex tw-items-center tw-justify-center tw-m-auto tw-gap-2 tw-w-fit tw-text-[#2A7DDE] tw-cursor-pointer tw-text-sm tw-font-normal"
                onClick={backToLogin}
              >
                <img src="/change_circle.svg" alt="edit phone" />
                اصلاح شماره موبایل
              </div>

              <div style={{ outline: 'none !important', border: 'none !important' }} className="d-flex border-radius px-1 overflow-hidden tw-bg-white tw-mx-auto">
                <div dir="ltr" className="tw-grid tw-grid-cols-4 tw-gap-4 *:tw-rounded-lg *:tw-p-2 *:tw-flex *:tw-items-center *:tw-outline-none *:tw-justify-center *:tw-text-center *:tw-size-10 *:tw-bg-white *:tw-transition-all *:tw-duration-300 none_eng tw-select-none">
                  {
                    [0, 1, 2, 3].map(index => (
                      <input
                        key={index}
                        onChange={e => updateInputFiled(index, e.target.value)}
                        onClick={() => setActiveOtpField(index)}
                        autoFocus={index === 0}
                        id={`otp-code-${index}`}
                        className={`border-gray-300 otp-code-input ${activeOtpField == index ? 'active-otp-field' : ''}`}
                        type="number"
                        inputMode="numeric"
                        maxLength="1"
                      />
                    ))
                  }
                </div>
              </div>

            </div>

            <button
              type="button"
              className="btn btn-link text-decoration-none tw-my-3"
              onClick={loginAPI}
              disabled={resendTimer > 0}
            >
              {
                resendTimer > 0
                  ?
                  `${formattedTimer(resendTimer)} تا درخواست مجدد کد`
                  :
                  <div className="tw-text-[#6C757D] tw-text-[16px] tw-font-normal">ارسال مجدد</div>
              }
            </button>
            <div className="d-flex flex-row mt-2">
              <button
                className="btn btn-primary tw-w-full"
                type="submit"
                disabled={loading || !twoFAcode}
                onClick={twofaAPI}
              >
                تایید
                {loading && (
                  <span
                    className="spinner-border spinner-border-sm ms-1"
                    role="status"
                    aria-hidden="true"
                  />
                )}
              </button>
            </div>
          </form>
        </div>
        <AuthFooter />
      </div>
    </section>
  );
};

export default TwoFA;
